@use 'src/global/variables.scss' as var;
@use 'src/global/mixins/link' as link;
@use 'src/global/mixins/sr-only' as sr;

c-welcome {
  display: block;
  padding: 12px 24px 0 24px;
  overflow-y: auto;
  border-radius: 0 0 8px 8px;
  background-color: var.$primary-color;
  color: var.$text-color-light;
  // IE fix to center the .text-container, which I gave display: inline-block,
  // so .text-container gets affected by text-align and centered
  text-align: center;
  hyphens: none;
  -webkit-hyphens: none;
  height: -webkit-fill-available;
  max-height: 610px;

  .sr-only {
    @include sr.sr-only();
  }

  a {
    @include link.link();
  }

  #cb-welcome-text {
    border: 2px solid white;
    border-radius: var.$bubble-border-radius;
    box-sizing: border-box;
    padding: 10px;
    margin-top: auto !important;
    margin-bottom: 10px;
  }

  #cb-header {
    .glow-unset {
      box-shadow: unset !important;
    }

    .glow-inset {
      box-shadow: inset 0 -5px 5px -2px white !important;
      padding: 12px 12px 17px 12px !important;
    }
  }

  .text-container {
    // IE Fix
    width: 100%;
    max-width: 30rem;
    font-size: 1em;
    box-sizing: border-box;
    padding: 0 clamp(0em, 5vw, 0em);
    display: inline-block;
    // To counter text-align: left of :host
    text-align: left;
  }

  button {
    font-size: min(max(0.7em, 4vw), 1.05em);
    background: var.$primary-color;
    border: 2px solid currentColor;
    color: var.$text-color-light;
    cursor: pointer;
    width: 100%;
    padding: 0.8rem 0;
    border-radius: 5px;
    &:not(:last-child) {
      margin-bottom: 1rem;
    }

    &:hover,
    &:focus {
      outline: none;
      border-color: var.$focus-color;
      box-shadow: 0 0 0 2px var.$focus-color;
    }
  }

  .welcome-small-button:nth-child(odd) {
    margin: 0 0.3rem 1rem 0;
  }
  .welcome-small-button:nth-child(even) {
    margin: 0 0 1rem 0.3rem;
  }
  .welcome-small-button {
    height: 60px;
    width: calc(50% - 0.3rem);
    padding: 5px 0;
  }

  .disclaimer {
    text-align: center;
  }
}

#cb-welcome-buttons {
  margin-top: 1rem;
  display: flex !important;
  flex-wrap: wrap !important;
}
